import { Grid, Paper } from "@material-ui/core";
import ExceptionCountsWidget from "./ExceptionCountsWidget/ExceptionCountsWidget";
import { useTitle } from "hooks/useTitle";
import { useSelector } from "react-redux";
import { loadsDashboardStyles } from "./style";
import { useGetLoadsStatusDashboardQuery } from "features/loads/loadsSlice";
import { loadStatuses } from "features/loads/enums";
import FilterService from "services/filterService";
import { DashboardFilters } from "./DashboardFilters";
import LoadingSpinner from "components/LoadingSpinner";
import LeadTimeWidget from "./LeadTimeWidget/LeadTimeWidget";
import OnTimePerformanceWidget from "./OnTimePerformanceWidget/OnTimePerformanceWidget";
import { useMemo } from "react";
import CostPerMileWidget from "./CostPerMileWidget/CostPerMileWidget";
import { hasPermission } from "components/Authorize/authorizeUtil";
import { permissions } from "components/Authorize/permissions/permissions";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import WorkorderApprovalWidget from "features/landing/components/FleetManagementDashboard/WorkorderApprovalWidget/WorkorderApprovalWidget";

const LoadsDashboard = () => {
    const classes = loadsDashboardStyles();
    useTitle('Loads Dashboard');

    const { dashboardFilters } = useSelector(state => state.loadsDashboardState);

    const hasInvoicePerm = hasPermission(permissions.LOADS.INVOICE.key);

    let { data: loads, error: loadListError, isFetching: isLoadingLoads } = useGetLoadsStatusDashboardQuery({ startDate: dashboardFilters['startDate'].value, endDate: dashboardFilters['endDate']?.value });
    loads = loads || [];

    loads = useMemo(() => {
        return loads?.map(l =>
        ({
            ...l,
            loadDistance: Math.min(Math.ceil(l?.miles / 249), 6)
        })
        );
    }, [loads]);

    const filteredData = FilterService.filter(dashboardFilters, null, loads, []);

    return <>
        <LoadingSpinner loading={isLoadingLoads} />
        <Grid container spacing={2}>
            <Grid item xs={12} >
                <Paper className={classes.filtersWrapper}>
                    <DashboardFilters loading={isLoadingLoads} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper className={classes.widgetWrapper}>
                    <ExceptionCountsWidget loads={filteredData} statuses={[loadStatuses.EXCEPTION]} loading={isLoadingLoads} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper className={classes.widgetWrapper}>
                    <LeadTimeWidget loads={filteredData} loading={isLoadingLoads} />
                </Paper>
            </Grid>
             <Grid item xs={12} md={4}>
                <Paper className={classes.widgetWrapper}>
                    <WorkorderApprovalWidget loadsOnly={true} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={hasInvoicePerm ? 4 : 6}>
                <Paper className={classes.widgetWrapper}>
                    <ExceptionCountsWidget loads={filteredData} statuses={[loadStatuses.CANCELLED, loadStatuses.CANCELLED_PARQ]} loading={isLoadingLoads} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={hasInvoicePerm ? 4 : 6}>
                <Paper className={classes.widgetWrapper}>
                    <OnTimePerformanceWidget loading={isLoadingLoads} />
                </Paper>
            </Grid>
            <Authorize profile={permissionProfiles.LOAD.LOAD_INVOICE}>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.widgetWrapper}>
                        <CostPerMileWidget loads={filteredData} loading={isLoadingLoads} />
                    </Paper>
                </Grid>
            </Authorize>
        </Grid>
    </>
}
export default LoadsDashboard;


/* 
Asusmptions:
-  The date filter filters the loads by the DeliveryEndDate 
-  In the lead time widget the y-axis are the months of the load accepeted date, 
    but if the load's CalcPickupDate is in the range of the filters and the load's accepted date is not, the load is not included in the graph
-  In the lead time graph we show all the months that are in the range - even if they don't have any loads
-  In the lead time statistics we show only the months that are in the range of the filters and have loads
*/